import React from 'react';
import { IQuestion, IQuestionAnswer } from '@/components/staffer/Grading/types';
import { checkIfAssignmentIsSlideShow } from '@/components/staffer/Grading/utils';
import ScoreEdit from '@/components/staffer/Grading/ScoreEdit';
import Comment from '@/components/shared/Grading/QuestionAnswerComment/Comment';
import useGradingStore from '@/components/staffer/Grading/useGradingStore';

interface TeacherCommentAndScoreProps {
  question: IQuestion;
  questionAnswer?: IQuestionAnswer;
}

const TeacherCommentAndScore = ({ question, questionAnswer }: TeacherCommentAndScoreProps) => {
  const {
    assignment,
    currentUser,
    programId,
  } = useGradingStore();

  // Show the score edit component if the assignment is a slideshow or if the question is auto-gradable
  // Notebook questions in a section, aka Reading Notes, can't be graded.
  const showScoreComponent = () => (
    checkIfAssignmentIsSlideShow(assignment)
    || question.auto_gradable
    || question.question_group.exercise_type !== 'Notebook'
  );

  return (
    <div className="commentGradeContainer tw-flex tw-justify-between">
      {questionAnswer && (
        <div className="tw-py-4 tw-flex tw-flex-col tw-justify-start tw-w-full tw-items-start">
          <strong className="tw-py-2">Teacher&apos;s Comments:</strong>
          <Comment
            commentingTeacher={questionAnswer.commenting_teacher}
            exerciseId={question.id}
            isTeacher={currentUser.role === 'Teacher'}
            lastUpdated={questionAnswer.comment_updated_at}
            programId={programId}
            questionAnswerId={questionAnswer.id}
            teacherComment={questionAnswer.teacher_comment}
            teacherStamp={questionAnswer.teacher_stamp}
            textAreaId={`text-area-${questionAnswer.id}`}
          />
        </div>
      )}
      {showScoreComponent() && <ScoreEdit question={question} questionAnswer={questionAnswer} />}
    </div>
  );
};

export default TeacherCommentAndScore;
